import React,{Component,Fragment}from 'react';
import { Header, Icon } from 'rsuite';
import SlidebarItem from './SildebarItem';
import CloseBar from './closebar';
import SlideContent from './SlideContent';
import MenuLogin from './MenuLogin';
import MenuPanel from './MenuPanel2';
import Flame from './flame';
import ONavBar from './NavBar';
import cookie from 'react-cookies';
import axios from 'axios';
import { baseUrl } from '../url';
import DBHandler from '../myBabylonjs/DBHandler';
import Game from '../myBabylonjs/game';
const openbar={
    left:'-120px'
}
const closebar={
    
}

class Slidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
          opened:true,
          item:[
              {id:'prof',content:'登录',icon:'avatar'},
              {id:'asset',content:'操作',icon:'magic2'}
            ],
            menuOpen:false,
            currentMenu:'',
            start:false,  
            geomodelList:[],
            modelLoaded:false,
            db:new DBHandler(),
            game:null
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
    }
    componentDidMount(){
        this.setState({
            game:new Game('renderCanvas')
        });
        
        this.getGeomodels();
        //this.state.game.engine.displayLoadingUI();
        this.getPlyGeomodels();
        //this.state.game.engine.hideLoadingUI();
    }
    componentWillUnmount(){
        // this.state.game.engine.displayLoadingUI();
        // this.getPlyGeomodels();
        
    }
    handleClick(){
        this.setState({
            opened: !this.state.opened,
            menuOpen:this.state.opened?false:this.state.menuOpen,
            start:true
        });
    }
    handleMenuClick(e){
        this.setState({
            menuOpen:!this.state.menuOpen,
            currentMenu:e.target.id+'-content',
            start:true
        });
    }
    loadItem(){
        return(
            this.state.item.map((item,index) => {
                return <SlidebarItem 
                        id={item.id} 
                        content={item.content} 
                        icon={item.icon} 
                        key={index}
                        onClick={this.handleMenuClick}
                        />
            })
        );
    }
    loadMenu(){
        return(
            this.state.item.map((item) => {
                return <SlideContent 
                        menuOpen={this.state.menuOpen}
                        currentMenu={this.state.currentMenu} 
                        id={item.id+'-content'}
                        key={item.id}
                        >
                        <h2 className='icon'>
                            {item.content}
                        </h2>
                        </SlideContent>
            })
        );
    }
    startScene(){
        this.setState({
            menuOpen:true,
            currentMenu:"asset-content",
            start:true
        })
    }
    displayWelcome(){
        if(!this.state.start){
            return(<Flame startScene={this.startScene.bind(this)}/>);
        }
    }

    getGeomodels= () =>{
        axios.get(baseUrl+"/api/Geomodels",
             { withCredentials: true }
            ).then(result=>{
                    this.setState({
                        geomodelList:result.data ,
                        modelLoaded:true
                    });
            cookie.save('geomodelList', result.data, { path: '/',maxAge:3600*2 });
            //console.log(this.state.geomodelList);
        }).catch(err=>{
            alert("模型列表获取失败"+err);
        });
    }
    async getPlyGeomodels(){
        
        if(this.state.geomodelList.length===0 || this.state.geomodelList===null){
            this.getGeomodels();
        }
        if(await this.state.db.geomodel.count()===0){
            this.state.game.engine.displayLoadingUI();
            axios.get(baseUrl+"/api/Geomodels/PlyData").then(result=>{
                
                let data = result.data.ply;
                data.forEach(async item=>{
                    if ((await this.state.db.geomodel.where({id: item.fileId}).count()) === 0) {
                        await this.state.db.geomodel.add({
                            id:item.fileId,
                            positions:item.position,
                            colors:item.color,
                            faces:item.face
                        })
                        //console.log(res)
                    }  
                });
            }).then(()=>{
                console.log(">>>>>>>>>>>数据库完全写入")
                this.state.game.engine.hideLoadingUI();
                return;
            });;
            return;
        }
        this.state.geomodelList.forEach(async item=>{
            
            if(await this.state.db.geomodel.where({id: item.fileId}).count()===0){
                this.state.game.engine.displayLoadingUI();
                console.log(item.fileId)
                axios.get(baseUrl+"/api/Geomodels/"+item.fileId).then(async result=>{
                    if(result.data.ply==="GlbGeomodel") return;
                    let data = result.data.ply;
                    await this.state.db.geomodel.add({
                        id:data.fileId,
                        positions:data.position,
                        colors:data.color,
                        faces:data.face
                    })
                }).then(()=>{
                    console.log(">>>>>>>>>>>数据库更新："+item.fileId)
                    this.state.game.engine.hideLoadingUI(); 
                });;    
            }
        });
    }
    deleteGeomodel = (index,id) => {        
        var tempdata = this.state.geomodelList;
        tempdata.splice(index, 1);
        //console.log(tempdata);
        axios.delete(baseUrl+"/api/Geomodels/" + id);
        this.setState({
            geomodelList: tempdata
        });
        cookie.save('geomodelList', this.state.geomodelList, { path: '/',maxAge:3600*2 });
        
    }
    
    render() {
      return (
        <Fragment>
        
            <div id="sidebar" style={this.state.opened?openbar:closebar} className={this.state.opened?'sidebar-move-right':'sidebar-move-left'}>
                <div>
                    <div className='headerStyle'><Icon icon={'globe2'} className='icon'/></div>
                    {this.loadItem()} 
                </div>    
                <CloseBar  open={this.state.opened} onClick={this.handleClick} />
            </div>
            <SlideContent menuOpen={this.state.menuOpen}
                          currentMenu={this.state.currentMenu} 
                          id={this.state.item[0].id+'-content'}
                          content={this.state.item[0].content}
                          >
                <MenuLogin 
                onClick={this.handleMenuClick} 
                allGeomodels = {this.state.geomodelList}
                deleteGeomodel = {this.deleteGeomodel}
                />
            </SlideContent>
            <SlideContent menuOpen={this.state.menuOpen}
                          currentMenu={this.state.currentMenu} 
                          id={this.state.item[1].id+'-content'}
                          content={this.state.item[1].content}
                          >
                <MenuPanel 
                geomodelList = {this.state.geomodelList}
                modelLoaded = {this.state.modelLoaded}
                getGeomodels = {this.getGeomodels}
                db={this.state.db}
                game = {this.state.game}
                />
            </SlideContent>
            {this.displayWelcome()}
            <ONavBar/>
            
        </Fragment>
      );
    }
  }

  export default Slidebar;